import { ProductionVolumesResponse } from "api/useProductionVolumesQuery";

import { NO_ROWS, Row, SKELETON_ROWS } from "./monthlyColumns";
import { formatCount } from "./monthlyFormat";

export type GridPanel = "emptyFilter" | "noProduction" | "error" | "skeleton";

interface GridStateInput {
  rowsHidden: boolean;
  isEmptyFilter: boolean;
  isLoading: boolean;
  isError: boolean;
  data?: ProductionVolumesResponse;
}

/** The rows the grid shows and the state panel over them, if any. */
export const getGridState = ({
  rowsHidden,
  isEmptyFilter,
  isLoading,
  isError,
  data
}: GridStateInput): { gridRows: Row[]; panel?: GridPanel } => {
  // Wells hidden on the map hide their rows here too, and the Data view's alert over them
  // must stay readable.
  if (rowsHidden) return { gridRows: NO_ROWS };
  if (isEmptyFilter || data?.totalWells === 0) {
    return { gridRows: NO_ROWS, panel: "emptyFilter" };
  }
  if (isError) return { gridRows: NO_ROWS, panel: "error" };
  if (isLoading) return { gridRows: SKELETON_ROWS, panel: "skeleton" };
  if (data && data.rows.length === 0) return { gridRows: NO_ROWS, panel: "noProduction" };
  return { gridRows: data?.rows ?? NO_ROWS };
};

// A filter that does not fit one page was only checked a page at a time.
export const noProductionText = ({
  totalWells,
  page,
  pageSize,
  sourceSetting
}: ProductionVolumesResponse) => {
  const wells =
    totalWells <= pageSize
      ? `the ${formatCount(totalWells)} wells`
      : `wells ${formatCount((page - 1) * pageSize + 1)}–${formatCount(
          Math.min(page * pageSize, totalWells)
        )}`;
  return `None of ${wells} have reported volumes for source: ${sourceSetting}.`;
};
